<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                    ref="districtCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="deviceCodeInput.options"
          :data="deviceCodeInput.data"
          :listener="deviceCodeInput.listener"
        />
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="activeStatusSelect.options"
          :data="activeStatusSelect.data"
          ref="activeStatusSelect"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="connectStatusSelect.options"
          :data="connectStatusSelect.data"
          ref="connectStatusSelect"
        ></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #updateDate="{item}">
            <td>{{ $helper.formatDate(item.updateDate) }}</td>
          </template>
          <template #activeStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.activeStatus == 1">Hoạt động</span>
              <span class="badge badge-danger" v-if="item.activeStatus == 0">Không hoạt động</span>
            </td>
          </template>
          <template #connectStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
              <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
            </td>
          </template>
          <template #volumn="{item}">
            <td>
              {{item.volumn + '%'}}
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="$hasAuthor('ROLE_ADMIN')"
                         color="warning"
                         variant="outline"
                         class="ml-1"
                         square
                         size="sm"
                         v-c-tooltip.hover="'Cấu hình'"
                         @click="setupConfigAPI(item)">
                  <CIcon name="cil-settings"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Cấu hình API" :show.sync="isShowPopupConfigAPI" :closeOnBackdrop="true">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            <CRow>
              <CCol sm="12" md="12" xs="12" xl="12">
                <BaseSelect :options="configAPI.ttcsContractorInformation.options"
                            :data="configAPI.ttcsContractorInformation.data"
                            ref="ttcsContractorInformation"></BaseSelect>
              </CCol>
              <!-- <CCol sm="12" md="12" xs="12" xl="12">
                <BaseSelect :options="configAPI.mhdtContractorInformation.options"
                            :data="configAPI.mhdtContractorInformation.data"
                            ref="mhdtContractorInformation"></BaseSelect>
              </CCol> -->
            </CRow>
          </CForm>
        </CCol>

      </CRow>
      <div slot="footer">
        <CButton color="primary" class="btn-action-primary" @click="submitConfigAPI()" :disabled="loadingConfigAPI.value"><i
          class="fa fa-check"></i> Đồng ý
        </CButton>
        &nbsp;
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupConfigAPI = false" :disabled="loadingConfigAPI.value"><i
          class="fa fa-times"></i> Đóng
        </CButton>
      </div>

      <BaseFormLoading :loading="loadingConfigAPI.value"></BaseFormLoading>
    </CModal>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2"
import {LOCATION_CODE_NAME} from "@/constant";

export default {
  name: "AudioDeviceList",
  components: {
    BaseTable,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: {value: false},
      loadingConfigAPI: {value: false},
      isShowPopupConfigAPI: false,
      actionData: {
        model: {
          selectedAll: false,
          fileSelectedId: null,
          fileSelectedName: null,
          listDeviceSelectedId: []
        }
      },
      configAPI: {
        idInput: {
          data: {
            name: "id",
            model: ""
          }
        },
        ttcsContractorInformation: {
          options: {
            filter: true,
            label: "Cấu hình truyền thanh cơ sở",
            selectAllText: "Chọn cấu hình truyền thanh cơ sở",
            'keyField': 'value',
            'valueField': 'text',
          },
          data: {
            name: "ttcsContractorInformation",
            model: null,
            items: [],
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.configAPI.ttcsContractorInformation.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Cấu hình truyền thanh cơ sở không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          }
        },
      },
      deviceCodeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "deviceCode",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      connectStatusSelect: {
        options: {
          filter: false,
          label: "Trạng thái kết nối",
        },
        data: {
          name: "connectStatus",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "0", value: "Mất kết nối"},
            {key: "1", value: "Kết nối"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: "Trạng thái hoạt động",
        },
        data: {
          name: "activeStatus",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "0", value: "Không hoạt động"},
            {key: "1", value: "Hoạt động"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "updateDate", label: "Cập nhật cuối"},
            {key: "deviceCode", label: "Mã thiết bị"},
            {key: "volumn", label: "Âm lượng"},
            {key: "activeStatus", label: "Trạng thái hoạt động"},
            {key: "connectStatus", label: "Trạng thái kết nối"},
            {key: "description", label: "Mô tả"},
            {key: "locationName", label: "Địa bàn"},
            {key: "supplierName", label: "NCC"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["index", "updateDate", "activeStatus", "connectStatus", "volumn", "action"],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false
        },
        dataSource: {
          url: "/audio-devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    
    setupConfigAPI(item) {
      this.configAPI.idInput.data.model = item.id;
      this.configAPI.ttcsContractorInformation.data.items = [];
      this.configAPI.ttcsContractorInformation.data.validator.isValid = true;
      this.configAPI.ttcsContractorInformation.data.validator.errorMessage = "";
      this.loadDataContractorInformation(item);
    },
    async loadDataContractorInformation(item) {
      let that = this;
      that.loading.value = true;
      await this.$helper.loadDataSource({
        loading: that.loading,
        isJsonContentType: false,
        dataSubmit: function () {
          return {typeSystem: 0};
        },
        url: "/contract_information/getListForSelectOption",
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let {data} = response.data;
            data.forEach(each => {
              // if (each.type == 0) {       // Truyền thanh cơ sở
              that.configAPI.ttcsContractorInformation.data.items.push(each);
              // } 
              // else if (each.type == 1) {    // Màn hình điện tử
              //   that.configAPI.mhdtContractorInformation.data.items.push(each);
              // }
            })
            that.isShowPopupConfigAPI = true;
            setTimeout(() => {
              if (item.ttcsContractorInformation) {
                that.configAPI.ttcsContractorInformation.data.model = item.ttcsContractorInformation;
              }
              // if (item.mhdtContractorInformation) {
              //   that.configAPI.mhdtContractorInformation.data.model = item.mhdtContractorInformation;
              // }
            });
          }
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
    submitConfigAPI: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loadingConfigAPI,
        url: "/audio-devices/config_api",
        dataRef: function () {
          return that.$data.configAPI;
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data),});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cấu hình thành công",});
            that.loadDataMainTable();
            that.isShowPopupConfigAPI = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
